module.exports = __webpack_public_path__ + "img/unishark_lime_mango.42c7ac1c.png";